import { getDefaultAnchorMailboxCookie } from 'owa-ows-gateway/lib/anchormailbox';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Utility to find out the anchor email address of a user. If that is not present get the email address from session settings.
 * @returns string - the email address
 */
export default function getDefaultAnchorMailboxForHeaders(): string {
    const defaultAnchorMailbox = getDefaultAnchorMailboxCookie();
    return defaultAnchorMailbox
        ? defaultAnchorMailbox
        : getUserConfiguration().SessionSettings.UserEmailAddress;
}
